import { render, staticRenderFns } from "./ProductPricesModal.vue?vue&type=template&id=70089b7d&scoped=true&"
import script from "./ProductPricesModal.vue?vue&type=script&lang=js&"
export * from "./ProductPricesModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductPricesModal.vue?vue&type=style&index=0&id=70089b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70089b7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
